import { debounce } from '@roc/feature-utils';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useStatusDashboardStyles } from './statusDashboardStyles';

interface ColumnFilterProps {
  value: string;
  onFilter: (value: string) => void;
}

// Text filter under a column title, like the floating filters of the leads dashboard:
// it filters 500 ms after the user stops typing
export const ColumnFilter = ({ value, onFilter }: ColumnFilterProps) => {
  const classes = useStatusDashboardStyles();
  const [text, setText] = useState(value);
  const onFilterRef = useRef(onFilter);
  onFilterRef.current = onFilter;

  // Opening another campaign clears its filters in the store
  useEffect(() => setText(value), [value]);

  const filter = useMemo(() => debounce((input: string) => onFilterRef.current(input), 500), []);

  return (
    <input
      className={classes.columnFilter}
      value={text}
      onChange={e => {
        setText(e.target.value);
        filter(e.target.value);
      }}
    />
  );
};
